"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionMetaItem_1 = __importDefault(require("./CollectionMetaItem"));
exports.default = CollectionMetaItem_1.default;
